import { createElement } from "../21946.js";

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var arrow_up_right_SvgArrowUpRight = function SvgArrowUpRight(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.6,
    strokeWidth: 1.5,
    d: "M6.563 3.824h5.674v5.674m0-5.674L6.563 9.498l-1.418 1.418"
  })));
};
/* export default */ const arrow_up_right = (arrow_up_right_SvgArrowUpRight);
export default arrow_up_right;
